export const agenticSectionNode = {
    group: "block",
    atom: true,
    selectable: true,
    draggable: false,
    isolating: true,
    attrs: {
        sectionId: {default: null},
        promptText: {default: ""},
        selectedAgent: {default: ""},
        requestId: {default: null},
        responseText: {default: ""},
        responseObject: {default: ""},
        responseStatus: {default: "idle"},
        responseUpdatedAt: {default: null},
        errorMessage: {default: ""},
        lastSubmittedPromptText: {default: ""},
        lastSubmittedAgent: {default: ""},
        createdAt: {default: null},
        updatedAt: {default: null},
    },
    
    parseDOM: [{
        tag: "div[data-node-type='agentic-section']",
        getAttrs(dom) {
            const parseOptionalNumber = (attributeName) => {
                const rawValue = dom.getAttribute(attributeName);
                if (rawValue === null || rawValue === "") return null;
                const parsedValue = Number(rawValue);
                return Number.isFinite(parsedValue) ? parsedValue : null;
            };

            return {
                sectionId: dom.getAttribute("data-section-id") || null,
                promptText: dom.getAttribute("data-prompt-text") || "",
                selectedAgent: dom.getAttribute("data-selected-agent") || "",
                requestId: dom.getAttribute("data-request-id") || null,
                responseText: dom.getAttribute("data-response-text") || "",
                responseObject: dom.getAttribute("data-response-object") || "",
                responseStatus: dom.getAttribute("data-response-status") || "idle",
                responseUpdatedAt: parseOptionalNumber("data-response-updated-at"),
                errorMessage: dom.getAttribute("data-error-message") || "",
                lastSubmittedPromptText: dom.getAttribute("data-last-submitted-prompt-text") || "",
                lastSubmittedAgent: dom.getAttribute("data-last-submitted-agent") || "",
                createdAt: parseOptionalNumber("data-created-at"),
                updatedAt: parseOptionalNumber("data-updated-at"),
            };
        },
    }],
    toDOM(node) {
        return ["div", {
            "data-node-type": "agentic-section",
            "data-section-id": node.attrs.sectionId || "",
            "data-prompt-text": node.attrs.promptText || "",
            "data-selected-agent": node.attrs.selectedAgent || "",
            "data-request-id": node.attrs.requestId || "",
            "data-response-text": node.attrs.responseText || "",
            "data-response-object": node.attrs.responseObject || "",
            "data-response-status": node.attrs.responseStatus || "idle",
            "data-response-updated-at": node.attrs.responseUpdatedAt || "",
            "data-error-message": node.attrs.errorMessage || "",
            "data-last-submitted-prompt-text": node.attrs.lastSubmittedPromptText || "",
            "data-last-submitted-agent": node.attrs.lastSubmittedAgent || "",
            "data-created-at": node.attrs.createdAt || "",
            "data-updated-at": node.attrs.updatedAt || "",
        }];
    },
};
